<template>
  <Card class="pa-2 subheading" :style="{ minHeight: '200px' }">
    <div id="info-header"><span class="subheading">{{ $t('SCB') }}</span> {{ $t('Live Data') }}</div>
    <DataTable
      class="scb-data-card"
      :headers="computedScbHeader"
      :items="scbData"
      :style="{ height: cardHeight, minHeight: '180px' }"
      :isPaginationFalse="true"
    >
      <template v-slot:firstCol="{ text }">
        <td>
          <v-layout row wrap align-center class="first-col-width">
            <div class="text__width">
              {{ text.name }}
            </div>
            <div v-if="status.parameter">
              <v-icon
                :color="
                  text[`${status.parameter}1`] == undefined ||
                  text[`${status.parameter}1`] == null ||
                  text[`${status.parameter}1`] == 'No Data'
                    ? 'grey'
                    : executeOp(
                        status.condition.op,
                        text[`${status.parameter}1`],
                        status.condition.value
                      )
                    ? 'green'
                    : 'red'
                "
                class="icon-class"
                size="10"
              >
                circle</v-icon
              >
            </div>
          </v-layout>
        </td>
      </template>
    </DataTable>
  </Card>
</template>

<script>
const momentTz = require('moment-timezone')
import _ from "lodash";
import { mapGetters } from "vuex";
import { mapGettersMixin } from "@/util/mixin/index";
import ScbService from "@/services/Scbs";

export default {
  mixins: [mapGettersMixin],
  props: {
    parameter: {
      type: Array,
      default: function () {
        return [];
      },
    },
    parameterNameMap: {
      type: Object,
      default: function () {
        return {};
      },
    },
    nameMap: {
      type: Object,
      default: function () {
        return {};
      },
    },
    status: {
      type: Object,
      default: function () {
        return {
          parameter: "",
          limits: {},
        };
      },
    },
    cardHeight: {
      type: String,
      default: "24vh",
    },
  },
  data() {
    return {
      generalHeader: [
        {
          text: "SCB Name",
          align: "center",
          sortable: false,
          value: "name",
          width: "20%",
        },
      ],
      scbHeader: [],
      scbData: [],
    };
  },
  computed: {
    ...mapGetters(["getSelectedPlantId", "getActivePlantInfo"]),
    computedScbHeader() {
      const cloneHeader = _.cloneDeep(this.scbHeader)
      return cloneHeader.map(el => {
        el['text'] = this.$t(el.text)
        return el
      })
    }
  },
  mounted() {
    this.parameter.forEach((p) => {
      const headerObj = {};
      headerObj["value"] = p;
      headerObj["text"] = Object.values(this.parameterNameMap)[0][0]["config"][
        p
      ]["name"];
      headerObj["align"] = "center";
      this.generalHeader.push(headerObj);
    });
    this.liveScbData();
    this.mqttHandler();
  },
  beforeDestroy() {
    this.$mqtt.unsubscribe(`live/${this.getSelectedPlantId}/scb`);
  },
  methods: {
    initialStateValues() {
      this.generalHeader = [
        {
          text: "SCB Name",
          align: "center",
          sortable: false,
          value: "name",
          width: "20%",
        },
      ];
      this.scbData = [];
      this.scbHeader = [];
    },
    isFloat(value) {
      if (
        typeof value === "number" &&
        !Number.isNaN(value) &&
        !Number.isInteger(value)
      ) {
        return true;
      }

      return false;
    },
    toThreeDecimalPlaces(props) {
      if (props !== undefined && props !== null) {
        if (this.isFloat(Number(props))) {
          return props == 0 ? 0 : Number.parseFloat(props).toFixed(3);
        } else {
          return props;
        }
      } else {
        return "No Data";
      }
    },
    liveScbData() {
      let idList = [
        ...new Set(
          Object.keys(this.nameMap).map((el) =>
            el.split("-").slice(0, 3).join("-")
          )
        ),
      ];
      const groupedBlock = _.groupBy(idList, function (id) {
        return id.split("-").slice(0, 1);
      });
      Object.keys(groupedBlock).forEach((blockId) => {
        const param = {
          plantId: this.getSelectedPlantId,
          index: "live",
          blockId: blockId,
          modifiedId: groupedBlock[blockId],
          date: momentTz().tz(this.getActivePlantInfo("timezone")).format("YYYY-MM-DD"),
          params: this.parameter,
        };
        ScbService.fetchScbTableData(param)
          .then((response) => {
            const responseValue = Object.values(response.data);

            this.scbHeader = [...this.generalHeader];
            responseValue[0][0].channel.forEach((ch) => {
              this.scbHeader.push({
                text: ch.name,
                value: ch.name,
                align: "center",
              });
            });
            this.scbData = [
              ...this.scbData,
              ...responseValue
                .map((el) => {
                  el[0].channel.forEach((ch) => {
                    el[0][ch.name] = this.toThreeDecimalPlaces(ch.value);
                  });
                  this.generalHeader.forEach((headerObj, ind) => {
                    if (ind != 0) {
                      el[0][headerObj.value] = this.toThreeDecimalPlaces(
                        el[0][headerObj.value]
                      );
                      // Breaker status
                      if (headerObj.value == "status1") {
                        if (
                          el[0][headerObj.value] != null &&
                          el[0][headerObj.value] != undefined && el[0][headerObj.value] != 'No Data'
                        ) {
                          el[0][`${headerObj.value}1`] = el[0][headerObj.value]
                          el[0][headerObj.value] = el[0][headerObj.value] == 1 ? "ON" : "OFF";
                        }
                      } else if (headerObj.value == "status2") { // SPD Status
                        if (
                          el[0][headerObj.value] != null &&
                          el[0][headerObj.value] != undefined  && el[0][headerObj.value] != 'No Data'
                        ) {
                          el[0][`${headerObj.value}1`] = el[0][headerObj.value]
                          el[0][headerObj.value] = el[0][headerObj.value] == 1 ? "Intact" : "Blown";
                        }
                      }
                    }
                  });
                  el[0]["name"] = this.nameMap[el[0].id];
                  return el[0];
                })
                .sort((a, b) => {
                  const aArr = a.id.split("-");
                  const bArr = b.id.split("-");
                  const baseA = aArr.slice(0, 3);
                  const baseB = bArr.slice(0, 3);
                  if (_.isEqual(baseA, baseB)) {
                    if (+aArr[aArr.length - 1] < +bArr[bArr.length - 1])
                      return -1;
                    if (+aArr[aArr.length - 1] > +bArr[bArr.length - 1])
                      return 1;
                  } else {
                    if (+baseA[baseA.length - 1] < +baseB[baseB.length - 1])
                      return -1;
                    if (+baseA[baseA.length - 1] > +baseB[baseB.length - 1])
                      return 1;
                  }
                  return 0;
                }),
            ];
          })
          .catch((err) => {
            console.log("ERROR LOADING LIVE SCB DATA", err);
          });
      });
    },
    mqttHandler() {
      this.$mqtt.subscribe(`live/${this.getSelectedPlantId}/scb`);
      this.$mqtt.on("message", (topic, message) => {
        if (topic.startsWith("live/")) {
          if (topic.endsWith("scb")) {
            const mqttData = JSON.parse(message.toString()).deviceList[0];
            if (!mqttData.exception) {
              const index = this.scbData.findIndex(
                (obj) => obj.id === mqttData.device_id
              );
              this.parameter.forEach((key) => {
                this.scbData[index][key] = this.toThreeDecimalPlaces(
                  mqttData[key]
                );

                // Breaker status
                if (key == "status1") {
                  if (
                    mqttData[key] != null &&
                    mqttData[key] != undefined &&
                    mqttData[key] != 'No Data'
                  ) {
                    this.scbData[index][`${key}1`] = mqttData[key]
                    this.scbData[index][key] = mqttData[key] == 1 ? "ON" : "OFF";
                  }
                } else if (key == "status2") { // SPD Status
                  if (
                    mqttData[key] != null &&
                    mqttData[key] != undefined &&
                    mqttData[key] != 'No Data'
                  ) {
                    this.scbData[index][`${key}1`] = mqttData[key]
                    el[0][headerObj.value] = mqttData[key] == 1 ? "Intact" : "Blown";
                  }
                }
              });
              // Updating channel key since we don't have access to the name
              mqttData.current.split(",").forEach((chVal, ind) => {
                this.scbData[index].channel[ind].value = chVal;
              });

              // Mapping the name of the channel to the root object
              this.scbData[index].channel.forEach((el) => {
                this.scbData[index][el.name] = this.toThreeDecimalPlaces(
                  el.value
                );
              });
            }
          }
        }
      });
      this.$mqtt.on("error", function (error) {
        console.log("ERROR: ", error);
      });

      this.$mqtt.on("offline", function () {
        console.log("offline");
      });

      this.$mqtt.on("reconnect", function () {
        console.log("reconnect");
      });
    },
    executeOp(op, value1, value2) {
      switch (op) {
        case "eq":
          return value1 === value2;
        case "neq":
          return value1 !== value2;
        case "gt":
          return value1 > value2;
        case "gteq":
          return value1 >= value2;
        case "lt":
          return value1 < value2;
        case "lteq":
          return value1 <= value2;
        default:
          return false;
      }
    },
  },
  watch: {
    async getSelectedPlantId(newVal, oldVal) {
      this.$mqtt.unsubscribe(`live/${oldVal}/scb`);
      this.initialStateValues();
      this.parameter.forEach((p) => {
        const headerObj = {};
        headerObj["value"] = p;
        headerObj["text"] = Object.values(this.parameterNameMap)[0][0][
          "config"
        ][p]["name"];
        headerObj["align"] = "center";
        this.generalHeader.push(headerObj);
      });
      await this.liveScbData();
      this.mqttHandler();
    },
  },
};
</script>

<style scoped>
.icon-class {
  margin-bottom: 2px;
  margin-left: 12px;
}

.first-col-width {
  width: 150px;
  word-wrap: break-word;
}

#info-header span {
  border-bottom: 2px solid #417cde;
  display: inline-block;
  vertical-align: top;
}

#info-header {
  padding-bottom: 8px;
}

.text__width {
  text-align: center;
  width: 120px;
}
</style>
<style>
.scb-data-card .v-table__overflow .v-table thead tr:first-child {
  position: sticky;
  top: 0px;
  z-index: 2;
  background: var(--v-primary-base);
  border-top: 1px solid #38405c;
}

.scb-data-card .v-table__overflow .v-table tbody td:first-child,
table.v-table thead th:first-child {
  position: sticky;
  left: 0;
  z-index: 1;
  background: var(--v-primary-base);
  border-right: 1px solid #38405c;
}
</style>
